// import anime from "animejs/lib/anime.es.js";
import Highway from "@dogstudio/highway";

import SliderMedia from "../components/sliderMedia";

var pastObject = {};

class Past extends Highway.Renderer {
  onEnter() {
    pastObject.sliderMedia = new SliderMedia().init();
  }
  onEnterCompleted() {}

  onLeave() {}

  onLeaveCompleted() {
    pastObject = {};
  }
}

export default Past;



// WEBPACK FOOTER //
// ./scripts/routes/past.js